import React from 'react';
import { Route, withRouter } from 'react-router';
import ArchiveList from './components/archiveList'

const ArchiveData = () => {
    return(
        <>
            <Route path="/download-archive/list" component={withRouter(ArchiveList)}  />
        </>
    )
}

export default ArchiveData